import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, Subscriber, throwError } from 'rxjs';
import { Note } from '../model/note';


@Injectable({
  providedIn: 'root'
})
export class NotesService {

  constructor(private http: HttpClient) { }

  getNotes(notesFocus: string) : Observable<Note> {
    
    var d = new Date();
    var n = d.getTime();

    return this.http.get<Note>("/static/tpdg/notes/" + notesFocus + "/" +notesFocus+".json?tt="+n);
  }


  submitInquiry(inquiry: string) : Observable<String> {
    return this.http.post<String>("/v1/inquiry/submit", inquiry);
  }


}
